'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addEmValues = exports.nameOfNamedValue = exports.unitPartOfUnitedNumberString = exports.numericPartOfUnitedNumberString = exports.elementsOfUnitedNumberString = undefined;

var _ramda = require('ramda');

var _formatting = require('./formatting');

var elementsOfUnitedNumberString = exports.elementsOfUnitedNumberString = function elementsOfUnitedNumberString(value) {
  var captures = /^(-?\d+(?:.\d+)?)([a-z|%]+)?$/.exec(value);
  if (!captures || (0, _ramda.any)(_ramda.isNil, [captures, captures[1], captures[2]])) {
    throw new Error('[cssapi] elementsOfUnitedNumber() Supplied value was not a number with a unit: \'' + value + '\'');
  }
  return [Number(captures[1]), captures[2]];
};

var numericPartOfUnitedNumberString = exports.numericPartOfUnitedNumberString = (0, _ramda.compose)((0, _ramda.view)((0, _ramda.lensIndex)(0)), elementsOfUnitedNumberString);

var unitPartOfUnitedNumberString = exports.unitPartOfUnitedNumberString = (0, _ramda.compose)((0, _ramda.view)((0, _ramda.lensIndex)(1)), elementsOfUnitedNumberString);

var nameOfNamedValue = exports.nameOfNamedValue = (0, _ramda.pipe)(_formatting.splitOnColon, _ramda.last);

var addEmValues = exports.addEmValues = (0, _ramda.curry)(function (emValue1, emValue2) {
  var value1 = (0, _ramda.unless)((0, _ramda.equals)(0), numericPartOfUnitedNumberString)(emValue1);
  var value2 = (0, _ramda.unless)((0, _ramda.equals)(0), numericPartOfUnitedNumberString)(emValue2);
  return value1 + value2 + 'em';
});


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/utils/parse.js
// module id = 246
// module chunks = 168707334958949